import React from 'react';
import PageActions, { PageActionsConfig } from './PageActions';

/**
 * Props pour le composant PageHeader
 */
interface PageHeaderProps {
  /** Titre de la page */
  title: string;
  /** Description/sous-titre de la page */
  description?: string;
  /** Configuration des actions */
  actionsConfig?: PageActionsConfig;
  /** Classe CSS supplémentaire */
  className?: string;
}

/**
 * Header compact : hauteur alignée sur Button sm.
 * Subtitle: hidden on mobile (< sm), visible from sm.
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actionsConfig,
  className = ''
}) => {
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 shrink-0 ${className}`}
    >
      <div className="min-w-0 flex-1">
        <h1 className="text-lg sm:text-xl xl:text-2xl font-bold text-gray-900 leading-none truncate">
          {title}
        </h1>
        {description && (
          <p className="mt-1 hidden text-sm text-gray-600 sm:block">
            {description}
          </p>
        )}
      </div>

      {actionsConfig && (
        <PageActions config={actionsConfig} className="w-full shrink-0 sm:w-auto" />
      )}
    </div>
  );
};

export default PageHeader;
